import React from 'react';
import Navbar from './global-components/navbar';
import Banner from './section-components/banner';
import Service from './section-components/service';
import Explore from './section-components/explore';
import FeaturedProperties from './section-components/featured-properties';
import Ads from './section-components/ads';
import PropertiesByCities from './section-components/properties-by-cities';
import RecentProperties from './section-components/recent-properties';
import FeaturedPorject from './section-components/featured-project';
import WhyChooseUs from './section-components/why-choose-us';
import OurPartner from './section-components/our-partner';
import Footer from './global-components/footer';
import FaqSection from './section-components/faq';
import PostList from './blog-components/post-list';
import Testimonial from './section-components/testimonial';
import ApartmentProperticesDubai from './section-components/apartment-propertices-dubai';
import TownhouseProperticesDubai from './section-components/townhouse-propertices-dubai';
import BlogContact from '../utils/blogContact';
import NavbarHome from './global-components/Homenavbar';

const Home_V1 = () => {
    return <div>
        <NavbarHome />
        <Banner />
        <Service />
        {/* <Explore /> */}
        <ApartmentProperticesDubai />
        <Ads />
        <TownhouseProperticesDubai />
        <FeaturedProperties />
        <PropertiesByCities />
        {/* <RecentProperties /> */}
        {/* <FeaturedPorject /> */}
        <WhyChooseUs />
        <OurPartner />
        <Testimonial />
        <FaqSection />
         <PostList />
    
    <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>

        <Footer />    
    </div>
}

export default Home_V1

